<div class="side-bar-content">
  <div *ngIf="!companyService.loading()">
    <mat-form-field>
      <mat-label>Select Company</mat-label>
      <mat-select [(ngModel)]="selectedValue" name="company" (ngModelChange)="selectCompany($event)">
        <mat-option *ngFor="let company of companyService.companies()" [value]="company.id">
          {{company.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="companyService.loading()">
    <mat-progress-spinner></mat-progress-spinner>
  </div>
  <div class="actions">
    <button *ngIf="user?.role !== Role.VIEWER" class="action-btn" matRipple (click)="navigate('events')">
      <mat-icon fontIcon="notifications"></mat-icon>
    </button>
    <button *ngIf="user?.role !== Role.VIEWER" class="action-btn" matRipple (click)="navigate('settings')">
      <mat-icon fontIcon="settings"></mat-icon>
    </button>
    <div class="action-btn" [matMenuTriggerFor]="menu" matRipple>
      <img [src]="userPicture" alt="Profile pic" referrerpolicy="no-referrer" />
    </div>
  </div>
  <mat-menu #menu="matMenu">
    <ul>
      <li tabindex="0" (click)="logOut()" (keydown.enter)="logOut()" (keydown.space)="logOut()" matRipple>
        <mat-icon fontIcon="logout"></mat-icon>
        LogOut
      </li>
    </ul>
  </mat-menu>
  <div class="links">
    <!--    <a-->
    <!--      routerLink="/"-->
    <!--      routerLinkActive="active-link"-->
    <!--      [routerLinkActiveOptions]="{ exact: true }"-->
    <!--      matRipple-->
    <!--      style="pointer-events: none"-->
    <!--    >-->
    <!--      <mat-icon fontIcon="show_chart"></mat-icon>-->
    <!--      Dashboard-->
    <!--    </a>-->
    <a (click)="this.toggleSideBar()" routerLink="/all-invoices" routerLinkActive="active-link" matRipple>
      <mat-icon fontIcon="library_books"></mat-icon>
      Invoices
    </a>
    <a
      *ngIf="user?.role !== Role.VIEWER"
      (click)="this.toggleSideBar()"
      routerLink="/clients"
      routerLinkActive="active-link"
      matRipple
    >
      <mat-icon fontIcon="how_to_reg"></mat-icon>
      Clients
    </a>
    <a
      *ngIf="user?.role !== Role.VIEWER"
      (click)="this.toggleSideBar()"
      routerLink="/projects"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: false }"
      matRipple
    >
      <mat-icon fontIcon="code"></mat-icon>
      Projects
    </a>
    <a
      *ngIf="user?.role !== Role.VIEWER"
      (click)="this.toggleSideBar()"
      routerLink="/recipients"
      routerLinkActive="active-link"
      matRipple
    >
      <mat-icon fontIcon="recent_actors"></mat-icon>
      Recipients
    </a>
    <a
      *ngIf="user?.role !== Role.VIEWER"
      (click)="this.toggleSideBar()"
      routerLink="/products"
      routerLinkActive="active-link"
      matRipple
    >
      <mat-icon fontIcon="pets"></mat-icon>
      Products
    </a>
    <a
      *ngIf="user?.role !== Role.VIEWER"
      (click)="this.toggleSideBar()"
      routerLink="/company-settings"
      routerLinkActive="active-link"
      matRipple
    >
      <mat-icon fontIcon="apartment"></mat-icon>
      Company Settings
    </a>
    <a
      *ngIf="user?.role !== Role.VIEWER"
      (click)="this.toggleSideBar()"
      routerLink="/organizations"
      routerLinkActive="active-link"
      matRipple
    >
      <mat-icon fontIcon="business"></mat-icon>
      Organizations
    </a>
    <a
      *ngIf="user?.role !== Role.VIEWER"
      (click)="this.toggleSideBar()"
      routerLink="/memberships"
      routerLinkActive="active-link"
      matRipple
    >
      <mat-icon fontIcon="group_add"></mat-icon>
      Memberships
    </a>
  </div>
  <div class="landing-message">
    <img src="../../../assets/img/invoice-illustration.svg" alt="Invoices" />
    <p>
      <span>Welcome to Billy!</span><br />
      Generate and manage your invoices!
    </p>
  </div>
</div>
